var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2.79365V29.2064C4 30.7492 5.23122 32 6.75 32H25.25C26.7688 32 28 30.7492 28 29.2064V7.35127C28 6.60502 27.7061 5.88979 27.1838 5.36503L22.6478 0.807413C22.133 0.29013 21.4381 0 20.714 0H6.75C5.23122 0 4 1.25076 4 2.79365ZM5.75 29.2064V2.79365C5.75 2.2326 6.19772 1.77778 6.75 1.77778H20.375V7.87302C20.375 8.92499 21.2145 9.77778 22.25 9.77778H26.25V29.2064C26.25 29.7674 25.8023 30.2222 25.25 30.2222H6.75C6.19772 30.2222 5.75 29.7674 5.75 29.2064ZM26.25 8V7.35127C26.25 7.07991 26.1431 6.81982 25.9532 6.629L22.125 2.78254V7.87302C22.125 7.94315 22.181 8 22.25 8H26.25Z",
    fill: "#9D9C9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13C8 12.25 8.25 12 9 12H23C23.75 12 24 12.25 24 13C24 13.75 23.75 14 23 14H9C8.25 14 8 13.75 8 13Z",
    fill: "#C9C7C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 17C8 16.25 8.25 16 9 16H23C23.75 16 24 16.25 24 17C24 17.75 23.75 18 23 18H9C8.25 18 8 17.75 8 17Z",
    fill: "#C9C7C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 21C8 20.25 8.25 20 9 20H23C23.75 20 24 20.25 24 21C24 21.75 23.75 22 23 22H9C8.25 22 8 21.75 8 21Z",
    fill: "#C9C7C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 25C8 24.25 8.25 24 9 24H23C23.75 24 24 24.25 24 25C24 25.75 23.75 26 23 26H9C8.25 26 8 25.75 8 25Z",
    fill: "#C9C7C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.25C0 8.42157 0.671573 7.75 1.5 7.75H16.5C17.3284 7.75 18 8.42157 18 9.25V24.25C18 25.0784 17.3284 25.75 16.5 25.75H1.5C0.671573 25.75 0 25.0784 0 24.25V9.25Z",
    fill: "#FE6767"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61898 17.7458V19.5H2.5V14.5H4.31065C4.86092 14.5 5.27953 14.6474 5.56645 14.9423C5.71209 15.0968 5.82584 15.283 5.90028 15.4884C5.97471 15.6939 6.00813 15.9141 5.99833 16.1345C6.00338 16.4254 5.93652 16.7124 5.80466 16.9659C5.67173 17.215 5.47247 17.4149 5.23288 17.5396C4.94518 17.6874 4.62898 17.7586 4.31065 17.7474L3.61898 17.7458ZM4.86093 16.1345C4.86093 15.6911 4.6365 15.4694 4.18768 15.4694H3.61898V16.7714H4.18768C4.6365 16.7758 4.86093 16.5635 4.86093 16.1345Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1855 18.2941C10.9766 18.6721 10.6614 18.9807 10.2789 19.1817C9.84957 19.4016 9.37209 19.5107 8.88981 19.4992H7V14.5009H8.88981C9.37294 14.4891 9.85156 14.5959 10.2839 14.8117C10.6644 15.0091 10.978 15.3144 11.1855 15.6894C11.3922 16.0924 11.5 16.5388 11.5 16.9917C11.5 17.4446 11.3922 17.891 11.1855 18.2941ZM9.88295 18.0431C10.1363 17.7506 10.2757 17.3768 10.2757 16.99C10.2757 16.6033 10.1363 16.2295 9.88295 15.937C9.58047 15.6716 9.18513 15.5365 8.78332 15.5614H8.20941V18.4171H8.79165C9.19034 18.4396 9.58203 18.3054 9.88295 18.0431Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.5V15.4627H13.2982V16.5585H15V17.478H13.2982V19.5H12V14.5H15.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.3b873c7b7ea3eb0a1ca4e2230a5d676b.svg";
export { ForwardRef as ReactComponent };